import { AI_AGENT_APP_STORES } from "@intrasync/ai-agent";

/**
 * AI Agent view stores from `@intrasync/ai-agent`.
 *
 * The package exports `AI_AGENT_APP_STORES` already in the host's
 * `{ name, store }` shape (`agentHubStore`, `agentHubDataStore`), so it spreads
 * straight in. Each class is instantiated as `new Store(rootStore)` by
 * RootStore. Names do not collide with existing host view stores (the retired
 * legacy AI Agent used `aiAgentStore`).
 */
const aiAgentStoreList = [...AI_AGENT_APP_STORES];

export default aiAgentStoreList;
